<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Tool</router-link> |
      <router-link to="/about">{{ $t("why") }}</router-link>
    </div>
    <div @click="toggleLanguage" class="locale-button">
      <p v-if="this.$i18n.locale === 'nl'">EN</p>
      <p v-if="this.$i18n.locale === 'en'">NL</p>
      </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  methods: {
    toggleLanguage () {
      this.$i18n.locale = this.$i18n.locale === 'nl' ? 'en' : 'nl'
    }
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
}

.locale-button {
  max-width: 30px;
  position: absolute;
  top: 0;
  right: 0;
  position: absolute;
  padding: 5px;
  margin: 10px;
  border-radius: 8px;
  cursor: pointer;

    &:hover {
      background: #42b983;
      color: white;
    }
}


@media only screen and (max-width: 600px) {
  #app {
    padding: 10px;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
